// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"359":"bcbdffe1","361":"77aa48f2","511":"1d082ded","767":"33def713"}[chunkId] + ".chunk.js";
};